import React, { Component } from 'react';
import { Icon } from "semantic-ui-react";
import moment from "moment";
import { adpLink } from "../../constants"
import { formatCurrency } from "../../utils/commonutils";
import { showFinancialNotesTable, showTedCollectionsTable } from "./functions";
import PayDetailDateCell from './PayDetailDateCell';

class ProdHurdle extends Component {

    generateProdHurdleTableRows = (payDetailsList) => {
        return payDetailsList.map((iData, index) => <tr key={index}>
            <td>
                <PayDetailDateCell row={iData} />
            </td>
            <td>
                {(iData.practice)}
            </td>
            <td>
                {formatCurrency(iData.care)}
            </td>
            <td>
                {formatCurrency(iData.adjustmentPrice)}
            </td>
            <td>
                {formatCurrency(iData.writeOffPrice * -1)}
            </td>
            <td>
                {formatCurrency(iData.billableCare)}
            </td>
            <td>
                {formatCurrency(iData.financialNotes)}
            </td>
            <td>
                {formatCurrency(iData.hourlyPay)}
            </td>
            <td>
                {formatCurrency(iData.bonusPay)}
            </td>
            <td>
                {formatCurrency(iData.totalPay)}
            </td>
        </tr>)
    }

    render() {
        const { details, providerData, startDate, earnings } = this.props;

        const { numberOfWorkedDays, patientVisits, patientVisitsPerDay, contractType, dentistWorkTimeType, prodAdjWo, doctorPayVariables, sortName, } = providerData;

        const annualizedPay = earnings * 12;
        const dailyRatePay = (earnings / numberOfWorkedDays);
        const hoursWorked = numberOfWorkedDays * 11; // Assuming 11-hour workdays
        const totalDailyHurdle = doctorPayVariables.dailyHurdle * numberOfWorkedDays;

        let { payChecks, financialNoteList, payDetailsList } = details;
        const prodHurdleTableRows = this.generateProdHurdleTableRows(payDetailsList);

        return (
            <div>
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>{sortName}</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Pay Month</p>
                                        <p>{moment(startDate).add(1, 'months').format('MMMM YYYY')}</p>
                                    </li>
                                    <li>
                                        <p>Work Month</p>
                                        <p>{moment(startDate).format('MMMM YYYY')}</p>
                                    </li>
                                    <li>
                                        <p>Work Days</p>
                                        <p>{numberOfWorkedDays}</p>
                                    </li>
                                    <li>
                                        <p>Hours Worked</p>
                                        <p>{hoursWorked}</p>
                                    </li>
                                    <li>
                                        <p>Hourly Rate</p>
                                        <p>{formatCurrency(doctorPayVariables.hourly_rate)}</p>
                                    </li>
                                    <li>
                                        <p>Daily Hurdle</p>
                                        <p>{formatCurrency(doctorPayVariables.dailyHurdle)}</p>
                                    </li>
                                    <li>
                                        <p>Total Period Hurdle</p>
                                        <p>{formatCurrency(totalDailyHurdle)}</p>
                                    </li>
                                    <li>
                                        <p>Total Month Earnings</p>
                                        <p>{formatCurrency(earnings)}</p>
                                    </li>
                                    <li>
                                        <p>Annualized Earnings</p>
                                        <p>{formatCurrency(annualizedPay)}</p>
                                    </li>
                                    <li>
                                        <p>Avg Daily Earnings</p>
                                        <p>{formatCurrency(dailyRatePay)}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits</p>
                                        <p>{patientVisits}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits/ Day </p>
                                        <p>{patientVisitsPerDay}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Contract Details</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Contract Type</p>
                                        <p>{contractType}</p>
                                    </li>
                                    <li>
                                        <p>Hourly Rate</p>
                                        <p>{formatCurrency(doctorPayVariables.hourly_rate)}</p>
                                    </li>
                                    <li>
                                        <p>Daily Hurdle</p>
                                        <p>{formatCurrency(doctorPayVariables.dailyHurdle)}</p>
                                    </li>
                                    <li>
                                        <p>Percentage Compensation</p>
                                        <p>{doctorPayVariables.percent_comp}%</p>
                                    </li>
                                    <li>
                                        <p>Gross to Billable Adjustment Percentage</p>
                                        <p>{100 - prodAdjWo}%</p>
                                    </li>
                                    <li>
                                        <p>Work Status</p>
                                        <p>{dentistWorkTimeType}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Production Hurdle Calculation Breakdown</h5>
                                <div className="calculation-explanation">
                                    <div className="calculation-step">
                                        <h6>Base Pay Calculation:</h6>
                                        <p>Hours Worked: {numberOfWorkedDays} days × 11 hours = {hoursWorked} hours</p>
                                        <p>Base Pay: {hoursWorked} hours × {formatCurrency(doctorPayVariables.hourly_rate)}/hour = {formatCurrency(hoursWorked * doctorPayVariables.hourly_rate)}</p>
                                    </div>
                                    <div className="calculation-step">
                                        <h6>Bonus Pay Calculation:</h6>
                                        <p>Total Period Hurdle: {formatCurrency(doctorPayVariables.dailyHurdle)} × {numberOfWorkedDays} days = {formatCurrency(totalDailyHurdle)}</p>
                                        <p>Production Above Hurdle: Total Production - Total Hurdle</p>
                                        <p>Bonus Pay: (Production Above Hurdle) × {doctorPayVariables.percent_comp}%</p>
                                    </div>
                                    <div className="calculation-step">
                                        <h6>Total Pay:</h6>
                                        <p>Total Pay = Base Pay + Bonus Pay + Financial Notes</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Accessing Your Pay Stub</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>ADP Link</p>
                                        <p><a href={adpLink} target="_blank" rel="noopener noreferrer"><Icon name='external alternate' />ADP</a></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                {
                                    payChecks && Object.entries(payChecks).map(([date, dateChecks], i) => <div key={i}>
                                        <div className="d-flex justify-content-between flex-wrap">
                                            <h5 className="mr10">{i + 1}{(1 + i) === 1 ? 'st' : 'nd'} Friday Gross Earnings
                                                Pre-Tax</h5>
                                            <strong className="secondaryColor text-right">{date}</strong>
                                        </div>
                                        <table className="table table-striped table-hover table-sm mt-0 mb-0">
                                            <thead>
                                                <tr>
                                                    <th>OFFICE</th>
                                                    <th className="text-right">EARNINGS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dateChecks.officeChecks.map((office, officeIndex) => (
                                                    <tr key={officeIndex}>
                                                        <td>{office.practice}</td>
                                                        <td className="text-right">{formatCurrency(office.check)}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td><strong>Total</strong></td>
                                                    <td className="text-right">
                                                        <strong>{formatCurrency(dateChecks.total)}</strong>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>)
                                }
                            </div>
                        </div>

                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Contract Information</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Pay Calculation Method</p>
                                        <p>Production Hurdle</p>
                                    </li>
                                    <li>
                                        <p>Base Pay Structure</p>
                                        <p>Hourly Rate × Hours Worked</p>
                                    </li>
                                    <li>
                                        <p>Bonus Structure</p>
                                        <p>Production Above Daily Hurdle</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Daily Breakdown</h5>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Practice</th>
                                                <th>Production</th>
                                                <th>Adjustment</th>
                                                <th>Write Off</th>
                                                <th>Billable Care</th>
                                                <th>Financial Notes</th>
                                                <th>Hourly Pay</th>
                                                <th>Bonus Pay</th>
                                                <th>Total Pay</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {prodHurdleTableRows}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        {showFinancialNotesTable(financialNoteList)}
                        {showTedCollectionsTable(payDetailsList)}
                    </div>
                </div>
            </div>
        );
    }
}

export default ProdHurdle;
